import React, { Component } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import { Redirect, Link } from 'react-router-dom';
import Select from 'react-select';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { SELECT_LABELS, selectPlaceholder, withSelectPlaceholder } from '../../services/selectOptions';

registerLocale('es', es);

const NOTA_OPTIONS = withSelectPlaceholder(
  [
    { value: '0', label: 'Ausente' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
    { value: '7', label: '7' },
    { value: '8', label: '8' },
    { value: '9', label: '9' },
    { value: '10', label: '10' },
  ],
  SELECT_LABELS.opcion
);

const SELECT_CLASS_NAMES = {
  control: () => 'md-form-page__select__control',
};

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

function formatNotaLabel(nota) {
  switch (nota) {
    case 1: return '1(uno)';
    case 2: return '2(dos)';
    case 3: return '3(tres)';
    case 4: return '4(cuatro)';
    case 5: return '5(cinco)';
    case 6: return '6(seis)';
    case 7: return '7(siete)';
    case 8: return '8(ocho)';
    case 9: return '9(nueve)';
    case 10: return '10(diez)';
    default: return '';
  }
}

export class UpdateHistoriaAcademicaExamen extends Component {
  static displayName = UpdateHistoriaAcademicaExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loadingInitial: true,
      loading: false,
      loadError: '',
      errorMessage: '',
      redirect: false,
      anio: { anioAcademicoCod: 0, anioAcademicoDescripcion: '', carrera: '' },
      materia: { codigo: 0, anioAcademicoDescripcion: '' },
      id: this.props.match.params.id,
      details: this.props.match.params.details,
      fecha: new Date(),
      observaciones: '',
      resultado: '',
      valueDictado: selectPlaceholder(SELECT_LABELS.opcion),
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get isReadOnly() {
    return this.state.details === '1';
  }

  componentDidMount() {
    const canAccess = constantClass.canAccess('HistoriaAcademicaExamen');
    if (canAccess) {
      this.populateData();
    } else {
      this.setState({ loadingInitial: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  async populateData() {
    this.setState({ loadingInitial: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/hex/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loadingInitial: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudieron cargar los datos de la historia académica.'
        ),
      });
      return;
    }

    const defaultValueAnioDictado = NOTA_OPTIONS.filter(
      (x) => x.value.toString() === data.returnModel.historiaAcademicaExamenNota.toString()
    );

    this.setState({
      loadingInitial: false,
      anio: {
        anioAcademicoCod: data.returnModel.alumnoxCarreraCod,
        anioAcademicoDescripcion: data.returnModel.alumnoxCarreraCodNavigation.alumnoNombre,
        carrera: data.returnModel.alumnoxCarreraCodNavigation.carreraNombre,
      },
      materia: {
        codigo: data.returnModel.materiaCarreraCod,
        anioAcademicoDescripcion: data.returnModel.materiaCarreraCodNavigation.materiaCarreraNombre,
      },
      resultado: data.returnModel.historiaAcademicaExamenResulta.trim(),
      fecha: constantClass.parseApiDate(data.returnModel.historiaAcademicaFechaExamen),
      observaciones: data.returnModel.historiaAcademicaExamenNota,
      valueDictado: defaultValueAnioDictado.length > 0
        ? defaultValueAnioDictado[0]
        : selectPlaceholder(SELECT_LABELS.opcion),
    });
  }

  handleDictadoChangeInput = (e) => {
    this.clearFeedback();
    this.setState({
      observaciones: e.value,
      valueDictado: e,
      resultado: e.value === '0' ? 'Ausente' : e.value >= '4' ? 'Aprobó' : 'Reprobó',
    });
  };

  handleFechaExamen = (date) => {
    this.clearFeedback();
    this.setState({ fecha: date });
  };

  handleSubmit(e) {
    e.preventDefault();
    if (this.isReadOnly) {
      return;
    }
    if (isSubmitInProgress(this.state.loading)) return;
    this.saveStudent();
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/hex', {
      method: 'POST',
      body: JSON.stringify({
        HistoriaAcademicaExamenCod: parseInt(this.state.id, 10),
        HistoriaAcademicaResultado: this.state.resultado,
        HistoriaAcademicaExamenNota: this.state.observaciones,
        HistoriaAcademicaFechaExamen: constantClass.serializeDateForApi(this.state.fecha),
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo actualizar la historia académica. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-hex" />;
    }

    const {
      loadingInitial,
      loading,
      loadError,
      errorMessage,
      anio,
      materia,
      fecha,
      observaciones,
      resultado,
      valueDictado,
    } = this.state;

    const isBusy = loading;
    const title = this.isReadOnly
      ? 'Ver datos de Historia Académica Examen'
      : 'Modificar Historia Académica Examen';
    const alumnoDisplay = anio.anioAcademicoDescripcion + ' - ' + anio.carrera;

    if (loadingInitial) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-hex">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <p className="md-form-page__skeleton"><em>Cargando datos...</em></p>
        </div>
      );
    }

    if (loadError) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-hex">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <div className="md-form-page__error" role="alert">{loadError}</div>
        </div>
      );
    }

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-hex">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">{title}</h1>
        <p className="md-form-page__subtitle">
          {this.isReadOnly
            ? 'Consulta los datos registrados de la historia académica de examen.'
            : 'Actualice la fecha, la nota o el resultado y guarde los cambios.'}
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Actualizando historia académica, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Alumno</span>
              <input
                className="md-form-page__input"
                type="text"
                value={alumnoDisplay}
                disabled
                readOnly
                aria-label="Alumno"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Materia</span>
              <input
                className="md-form-page__input"
                type="text"
                value={materia.anioAcademicoDescripcion}
                disabled
                readOnly
                aria-label="Materia"
              />
            </div>

            <div className="md-form-page__field">
              {this.isReadOnly ? (
                <>
                  <span className="md-form-page__label">Fecha de Examen</span>
                  <input
                    className="md-form-page__input"
                    type="text"
                    value={constantClass.formatDisplayDate(fecha)}
                    disabled
                    readOnly
                    aria-label="Fecha de examen"
                  />
                </>
              ) : (
                <>
                  <label className="md-form-page__label" htmlFor="hex-fecha-examen">
                    Fecha de Examen
                  </label>
                  <DatePicker
                    id="hex-fecha-examen"
                    className="md-form-page__input"
                    locale="es"
                    closeOnScroll
                    selected={fecha}
                    onChange={this.handleFechaExamen}
                    disabled={isBusy}
                    dateFormat="dd/MM/yyyy"
                  />
                </>
              )}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Nota</span>
              {this.isReadOnly ? (
                <input
                  className="md-form-page__input"
                  type="text"
                  value={formatNotaLabel(observaciones)}
                  disabled
                  readOnly
                  aria-label="Nota"
                />
              ) : (
                <div className="md-form-page__select-wrap">
                  <Select
                    inputId="hex-nota"
                    classNamePrefix="md-form-page__select"
                    classNames={SELECT_CLASS_NAMES}
                    value={valueDictado}
                    options={NOTA_OPTIONS}
                    onChange={this.handleDictadoChangeInput}
                    isDisabled={isBusy}
                  />
                </div>
              )}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Resultado</span>
              <input
                className="md-form-page__input"
                type="text"
                value={resultado}
                disabled
                readOnly
                aria-label="Resultado"
              />
            </div>

            {!this.isReadOnly ? (
              <div className="md-form-page__actions">
                <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                  Confirmar
                </button>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    );
  }
}
